import { useUrlManagerContext } from '@couchbasecloud/base-ui/hooks/use-url-manager-context/use-url-manager-context';
import { useUrlManager as useUrlManagerCapella } from 'hooks/use-url-manager-capella/use-url-manager-capella';

export const useUrlManager: typeof useUrlManagerCapella = useUrlManagerContext;
